var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.finishedLoading)?_c('v-skeleton-loader',{attrs:{"type":"card"}}):_c('apexchart',{ref:"chartusMaximus",attrs:{"type":"bar","height":"250","options":_vm.chartOptionsData,"series":_vm.seriesData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }